const {
  REACT_APP_PAYME_PUBLIC_KEY,
  REACT_APP_PAYME_SECRET_KEY,

  REACT_APP_PAYME_ACCESS_TOKEN_URL_DEV,

  REACT_APP_PAYME_ACCESS_TOKEN_URL_PROD,

  REACT_APP_PAYME_ACCESS_TOKEN_API_VERSION,

  REACT_APP_PAYME_ACCESS_TOKEN_AUDIENCE_PROD,

  REACT_APP_PAYME_NONCE_URL_DEV,

  REACT_APP_PAYME_NONCE_URL_PROD,

  REACT_APP_PAYME_NONCE_API_VERSION,

  REACT_APP_PAYME_NONCE_AUDIENCE_DEV,
  REACT_APP_PAYME_NONCE_AUDIENCE_PROD,
} = process.env;

// Continue using the PayMe production variables even in development mode
const accessTokenUrl = REACT_APP_PAYME_ACCESS_TOKEN_URL_PROD;
const nonceUrl = REACT_APP_PAYME_NONCE_URL_PROD;

// Validate URLs before using them
if (!accessTokenUrl || !nonceUrl) {
  throw new Error(
    "PayMe API URLs are not configured correctly in environment variables"
  );
}

let cachedToken: { accessToken: string; expiresAt: number } | null = null;

export const paymeApi = {
  async getAccessToken() {
    const now = Date.now();
    if (cachedToken && cachedToken.expiresAt > now) {
      return cachedToken.accessToken;
    }

    try {
      const headers = {
        "Content-Type": "application/json",
        // "ALG-API-VERSION": REACT_APP_PAYME_ACCESS_TOKEN_API_VERSION || "",
      };

      const body = {
        action: "authorize",
        grant_type: "password",
        audience: REACT_APP_PAYME_ACCESS_TOKEN_AUDIENCE_PROD,
        client_id: REACT_APP_PAYME_PUBLIC_KEY,
        client_secret: REACT_APP_PAYME_SECRET_KEY,
        scope: "create:token",
      };

      const response = await fetch(accessTokenUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      cachedToken = {
        accessToken: data.access_token,
        expiresAt: now + data.expires_in * 1000 - 5000,
      };

      return cachedToken.accessToken;
    } catch (error) {
      console.error("Failed to get access token:", error);
      throw error;
    }
  },

  async getNonce() {
    try {
      const accessToken = await this.getAccessToken();
      if (!accessToken) {
        throw new Error("Failed to get access token");
      }

      const headers = {
        "Content-Type": "application/json",
        // "ALG-API-VERSION": REACT_APP_PAYME_NONCE_API_VERSION || "",
        Authorization: `Bearer ${accessToken}`,
      };

      const body = {
        action: "create.nonce",
        audience: REACT_APP_PAYME_NONCE_AUDIENCE_PROD,
        client_id: REACT_APP_PAYME_PUBLIC_KEY,
        scope: "create:token",
      };

      const response = await fetch(nonceUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      if (!data.nonce) {
        throw new Error("No nonce received in response");
      }

      return data.nonce;
    } catch (error) {
      console.error("Failed to get nonce:", error);
      throw error;
    }
  },
};
